import React, { FC, useEffect, useState } from "react";
import { Button, Col, Divider, Form, Input, notification, Radio, Row } from "antd";
import { useTranslation } from "react-i18next";
import {
    ITerminalPRMRInfoEInvoiceCfg,
    saveTerminalPrmInfoEInvoiceCfg,
    terminalPrmInfoEInvoiceCfg
} from "../../../services/einvoice/einvoice";


interface IProps {
    terminalId: string;
}

export const TerminalPrmEInvoice: FC<IProps> = ({ terminalId }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [formValues, setFormValues] = useState<ITerminalPRMRInfoEInvoiceCfg>();
    const [btnLoading, setBtnLoading] = useState<boolean>(false);
    useEffect(
        function () {
            if (terminalId !== "") {
                terminalPrmInfoEInvoiceCfg({ terminal_id: terminalId }).then((res) => {
                    if (res.status === 0) {
                        setFormValues(res.data);
                        form.setFieldsValue(res.data);
                    }
                });
            }
        },
        [terminalId]
    );
    const saveForm = (values) => {
        if (formValues === undefined) {
            return;
        }
        setBtnLoading(true);
        saveTerminalPrmInfoEInvoiceCfg({
            id: formValues["id"],
            terminalId: terminalId,
            einvoice: values["einvoice"],
        })
            .then((res) => {
                if (res.status === 0) {
                    notification.success({
                        message: "save success",
                    });
                }
            })
            .finally(() => {
                setBtnLoading(false);
            });
    };
    return (
        <Row gutter={10} style={{ marginTop: "20px" }} hidden={terminalId === ""}>
            <div className="form-content-container-content">
                <Form layout="vertical" form={form} initialValues={formValues} onFinish={saveForm}>
                    <Row gutter={30}>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvEnable")} name={["einvoice", "EinvEnable"]}>
                                <Radio.Group>
                                    <Radio value={true}>True</Radio>
                                    <Radio value={false}>False</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvPaperFlag")} name={["einvoice", "EinvPaperFlag"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvCarrierQRFlag")} name={["einvoice", "EinvCarrierQRFlag"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvCarrierCardFlag")} name={["einvoice", "EinvCarrierCardFlag"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvDonateFlag")} name={["einvoice", "EinvDonateFlag"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvUserSelectFlag")} name={["einvoice", "EinvUserSelectFlag"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvDefLoveCode")} name={["einvoice", "EinvDefLoveCode"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvTimeOut")} name={["einvoice", "EinvTimeOut"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvExecuteAfterTxnFlag")} name={["einvoice", "EinvExecuteAfterTxnFlag"]}>
                                <Radio.Group>
                                    <Radio value={true}>True</Radio>
                                    <Radio value={false}>False</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvHostUrl")} name={["einvoice", "EinvHostUrl"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvAppID")} name={["einvoice", "EinvAppID"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvApiKey")} name={["einvoice", "EinvApiKey"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvQrcodeKey")} name={["einvoice", "EinvQrcodeKey"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvInvoiceType")} name={["einvoice", "EinvInvoiceType"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvTaxType")} name={["einvoice", "EinvTaxType"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvTaxRate")} name={["einvoice", "EinvTaxRate"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvSellerIdentifier")} name={["einvoice", "EinvSellerIdentifier"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvShopNo")} name={["einvoice", "EinvShopNo"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvTerminalId")} name={["einvoice", "EinvTerminalId"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvPosId")} name={["einvoice", "EinvPosId"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvTEL")} name={["einvoice", "EinvTEL"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvDefDescription")} name={["einvoice", "EinvDefDescription"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvPrinterHal")} name={["einvoice", "EinvPrinterHal"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvPrinterIf")} name={["einvoice", "EinvPrinterIf"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvPrinterBTName")} name={["einvoice", "EinvPrinterBTName"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvPrinterBTMac")} name={["einvoice", "EinvPrinterBTMac"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvUploadFailedLimit")} name={["einvoice", "EinvUploadFailedLimit"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvTxnTimeout")} name={["einvoice", "EinvTxnTimeout"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvRequestNetwork")} name={["einvoice", "EinvRequestNetwork"]}>
                                <Radio.Group>
                                    <Radio value={true}>True</Radio>
                                    <Radio value={false}>False</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvRequestNetworkType")} name={["einvoice", "EinvRequestNetworkType"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvSubMerchantID")} name={["einvoice", "EinvSubMerchantID"]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col flex="300px">
                            <Form.Item label={t("form.EinvUploadFailedEnable")} name={["einvoice", "EinvUploadFailedEnable"]}>
                                <Radio.Group>
                                    <Radio value={true}>True</Radio>
                                    <Radio value={false}>False</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Divider />
                <div>
                    <Button
                        type="primary"
                        shape="round"
                        style={{ width: "200px", float: "right" }}
                        htmlType="submit"
                        loading={btnLoading}
                        onClick={() => form.submit()}
                    >
                        {t("button.save")}
                    </Button>
                </div>
            </div>
        </Row>
    );
};
